module.exports = __webpack_public_path__ + "img/imgpsh_fullsize_anim.0f9c75ed.png";